import { FactoryProvider } from '@angular/core';

import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

import { DOCUMENT_UPLOAD_TRANSLATIONS, DocumentUploadTranslations } from '@hdms/shared/ui-core';

export const DOCUMENT_UPLOAD_TRANSLATIONS_PROVIDER: FactoryProvider = {
  provide: DOCUMENT_UPLOAD_TRANSLATIONS,
  deps: [I18NEXT_SERVICE],
  useFactory: (i18NextService: ITranslationService): DocumentUploadTranslations => ({
    deleteButtonLabel: i18NextService.t('common.label.documentUpload.delete'),
    dictFileTooBig: i18NextService.t('common.label.documentUpload.messages.fileTooBig', {
      interpolation: { skipOnVariables: true }
    }),
    dictInvalidFileType: i18NextService.t('common.label.documentUpload.messages.invalidFileType'),
    noFileSelectedLabel: i18NextService.t('common.label.documentUpload.noFile'),
    uploadButtonLabel: i18NextService.t('common.label.documentUpload.upload'),
    uploadSystemErrorMessage: i18NextService.t('common.label.documentUpload.messages.uploadSystemError'),
    dragAndDropLabel: i18NextService.t('common.label.documentUpload.dragAndDrop.label'),
    dragAndDropHint: i18NextService.t('common.label.documentUpload.dragAndDrop.hint')
  })
};
